import { createTheme } from '@material-ui/core/styles';
import {
  DOVE_GRAY,
  EBONY_CLAY,
  GRAY90,
  LOGAN,
  PAUA_BLUE,
  ROSE,
  ROSE_SHADE,
  SILVER_CHALICE,
  WHITE
} from './colors';

const FONTS = [
  'Gilroy',
  'Noto Sans CJK TC',
  'Noto Sans TC',
  'Helvetica',
  'Arial',
  'sans-serif',
];

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 450,
      md: 800,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      main: ROSE,
    },
    secondary: {
      main: PAUA_BLUE,
    },
    text: {
      secondary: LOGAN,
    },
    divider: GRAY90,
  },
  typography: {
    fontFamily: FONTS.join(','),
    fontSize: 16,
    h6: {
      color: EBONY_CLAY,
      fontSize: '1.125rem',
      lineHeight: 4 / 3,
      fontWeight: 700,
      letterSpacing: 0,
    },
    body2: {
      color: EBONY_CLAY,
      fontSize: '1rem',
      lineHeight: 3 / 2,
      fontWeight: 500,
      letterSpacing: 0,
    },
    body1: {
      color: SILVER_CHALICE,
      fontSize: '1rem',
      lineHeight: 3 / 2,
      fontWeight: 300,
      letterSpacing: 0,
    },
    subtitle1: {
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 3 / 2,
      letterSpacing: 0,
    },
    caption: {
      fontSize: '0.75rem',
      color: DOVE_GRAY,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 8,
        minWidth: 104,
        padding: 14,
      },
      containedPrimary: {
        backgroundColor: ROSE,
        color: WHITE,
        boxShadow: 'unset',
        borderRadius: '50px',
        '&:hover': {
          backgroundColor: ROSE_SHADE,
        },
      },
      containedSecondary: {
        backgroundColor: PAUA_BLUE,
        color: WHITE,
        boxShadow: 'unset',
        borderRadius: '50px',
        '&:hover': {
          backgroundColor: PAUA_BLUE,
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        borderColor: SILVER_CHALICE,
        borderRadius: 5,
      },
      adornedEnd: {
        paddingRight: 0,
      },
    },
    MuiFilledInput: {
      adornedEnd: {
        paddingRight: 0,
      },
    },
    MuiSelect: {
      outlined: {
        padding: '8px 24px 8px 24px',
      },
    },
    MuiMenuItem: {
      root: {
        color: EBONY_CLAY,
      },
    },
    // https://github.com/mui-org/material-ui/issues/16866
    MuiRadio: {
      root: {
        '&&:hover': {
          backgroundColor: 'transparent',
        },
        '&$checked': {
          '&&:hover': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiSlider: {
      root: {
        '@media (pointer: coarse)': {
          padding: '20px 0px 5px 0px',
        },
      },
      thumb: {
        width: 24,
        height: 24,
        marginTop: -10,
        border: '2px solid currentColor',
      },
      track: {
        height: 4,
        borderRadius: 4,
      },
      rail: {
        height: 4,
        borderRadius: 4,
        color: '#dcdcdc',
      },
    },
  },
});

export default theme;
